import { useState, useEffect } from 'react';
import { Outlet, NavLink, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useTheme } from '../context/ThemeContext';
import api from '../utils/api';

const nav = [
  { path:'/',          icon:'⊞', label:'Dashboard',  end:true },
  { path:'/clients',   icon:'👥', label:'Clients' },
  { path:'/quotations',icon:'📋', label:'Quotations' },
  { path:'/invoices',  icon:'🧾', label:'Invoices' },
  { path:'/renewals',  icon:'🔄', label:'Renewals', badge:true },
];
const adminNav = [
  { path:'/users',    icon:'🛡️', label:'Users' },
  { path:'/settings', icon:'⚙️', label:'Settings' },
];

export default function Layout() {
  const { user, logout } = useAuth();
  const { theme, toggleTheme } = useTheme();
  const location = useLocation();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [alerts, setAlerts] = useState([]);

  useEffect(() => {
    api.get('/renewals/alerts').then(r => setAlerts(r.data.data || [])).catch(() => {});
  }, []);

  useEffect(() => { setOpen(false); }, [location]);

  const titles = { '/':'Dashboard','/clients':'Clients','/quotations':'Quotations','/invoices':'Invoices','/renewals':'Renewals','/settings':'Settings','/users':'User Management' };
  const title = Object.entries(titles).find(([k]) => location.pathname === k || (k !== '/' && location.pathname.startsWith(k)))?.[1] || 'QuotePro';
  const isAdmin = user?.role === 'admin';

  return (
    <div className="app-layout">
      <div className={`sidebar-overlay ${open ? 'show' : ''}`} onClick={() => setOpen(false)} />

      <aside className={`sidebar ${open ? 'open' : ''}`}>
        <div className="sidebar-logo">
          <div className="logo-icon">💼</div>
          <div className="logo-text">Quote<span>Pro</span></div>
        </div>

        <nav className="sidebar-nav">
          <div className="nav-section">Menu</div>
          {nav.map(item => (
            <NavLink key={item.path} to={item.path} end={!!item.end}
              className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}>
              <span className="nav-icon">{item.icon}</span>
              {item.label}
              {item.badge && alerts.length > 0 && <span className="nav-badge">{alerts.length}</span>}
            </NavLink>
          ))}
          {isAdmin && (
            <>
              <div className="nav-section" style={{ marginTop:10 }}>Admin</div>
              {adminNav.map(item => (
                <NavLink key={item.path} to={item.path}
                  className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}>
                  <span className="nav-icon">{item.icon}</span>{item.label}
                </NavLink>
              ))}
            </>
          )}
        </nav>

        <div className="sidebar-footer">
          <div className="user-pill">
            <div className="user-avatar">{user?.name?.[0]?.toUpperCase()}</div>
            <div className="user-info">
              <div className="user-name">{user?.name}</div>
              <div className="user-role">{user?.role}</div>
            </div>
          </div>
          <button className="btn btn-secondary" style={{ width:'100%',justifyContent:'center',fontSize:13 }} onClick={logout}>
            🚪 Logout
          </button>
        </div>
      </aside>

      <div className="main-content">
        <header className="topbar">
          <div className="topbar-left">
            <div className="hamburger" onClick={() => setOpen(true)}>
              <span/><span/><span/>
            </div>
            <h1 style={{ fontSize:17,fontWeight:700,fontFamily:'Syne,sans-serif' }}>{title}</h1>
          </div>
          <div className="topbar-right">
            {/* Theme toggle */}
            <button className="theme-btn" onClick={toggleTheme} title={`Switch to ${theme==='dark'?'light':'dark'} mode`}>
              {theme === 'dark' ? '☀️' : '🌙'} {theme === 'dark' ? 'Light' : 'Dark'}
            </button>
            {/* Renewal bell */}
            {alerts.length > 0 && (
              <button className="btn btn-icon btn-warn" onClick={() => navigate('/renewals')} title={`${alerts.length} upcoming renewals`}>
                🔔
                <span style={{ position:'absolute',top:-4,right:-4,background:'var(--err)',color:'#fff',borderRadius:'50%',width:15,height:15,fontSize:9,display:'flex',alignItems:'center',justifyContent:'center',fontWeight:700 }}>{alerts.length}</span>
              </button>
            )}
            <div style={{ fontSize:12,color:'var(--text3)' }}>
              {new Date().toLocaleDateString('en-IN',{weekday:'short',day:'2-digit',month:'short'})}
            </div>
          </div>
        </header>

        <div className="page-content">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
